<template>
  <div id="app">
    <router-view style="height: 100%"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      res: {}
    };
  },
  mounted() {
    // 本地加载请求静态json文件的形式
    // this.axios.get('/json/user/login.json').then((res) => {
    //   this.res = res;
    // })
    // 通过easy-mock平台实现mock
    // 将axios中axios.defaults.baseURL = ''地址换为easy-mock项目地址
    // this.axios.get('/user/login').then((res) => {
    //   this.res = res;
    // })
    // 通过mockjs实现mock
    // this.axios.get('/user/login').then((res) => {
    //   this.res = res;
    // })
    if (this.$cookie.get('userId')) {
      this.getUserInfo();
      this.getCartSum();
    }
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      this.$api.mall.getUserInfo({}).then((res = {}) => {
        // 保存到vuex里面
        this.$store.dispatch('saveUserName', res.username);
      });
    },
    // 获取购物车商品数量
    getCartSum() {
      this.$api.mall.getCartSum({}).then((res = 0) => {
        // 保存到vuex里面
        this.$store.dispatch('saveCartCount', res);
      });
    }
  }
};
</script>
<style lang="scss">
.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title {
    background-color: #FFF;
    float: none;
    height: 46px;
    line-height: 46px;
    padding: 0px 20px;
    color: #909399;
    border-bottom: 1px solid #f1f1f1;
}
.el-form-item {
    margin-bottom: 10px;
}
.el-input .el-input__inner{
   //border: none !important;
  //background: none !important;
}
.v-modal{
  z-index: 1999 !important;
}
.vjs-poster {
  width: 100%; /* 设置宽度 */
  height: 100%; /* 设置高度 */
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  /* 其他样式 */
}
.el-icon-arrow-down:before{
  content: '';
}
.el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
  margin-top: 3px;
}
.el-dialog__body{
   padding: 0px;
}
.el-dialog{
  background: none;
  box-shadow: none;
}
.el-submenu__icon-arrow {
  background-image: url('~@/assets/img/01-1.png');
  background-repeat: no-repeat;
  background-size: contain;
  width: 6px;
  height: 6px;
  transform: none;
}
  /* 渐变设置 */
  .MainFade-enter-from,
  .MainFade-leave-to {
    transform: translateX(20px);
    opacity: 0;
  }

  .MainFade-enter-to,
  .MainFade-leave-from {
    opacity: 1;
  }

  .MainFade-enter-active {
    transition: all 0.7s ease;
  }

  .MainFade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.6, 0.6, 1);
  }

.video-js .vjs-big-play-button {
  border: 0.06666em solid #00969a !important;
  background-color: #00969a !important;
  color: #fff;
}

.el-select .el-input__inner:hover {
  border-color: #00969a;
}

.el-select-dropdown__wrap {
  max-height: 440px;
}

.el-select .el-input__inner:focus {
  border-color: #00969a;
}

.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
  border-color: #00969a;
}

.el-select .el-input__inner {
  border: 2px solid #00969a;
  background: none;
  border-radius: 0px;
  color: #00969a;
  font-weight: 600;
}

.el-select-dropdown__item.selected {
  color: #fff;
}

.el-select-dropdown {
  border: none;
}

.el-icon-arrow-up:before {
  content: "\e6e1";
  color: #00969a;
}

.el-select-dropdown__item {
  color: #fff;
  padding: 0 20px !important;
}

.el-select-dropdown__list {
  background: #00969a;
}

.el-popper[x-placement^=bottom] .popper__arrow::after {
  border-bottom-color: #00969a;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #00969a;
  font-weight: 600;

  span {
    border-bottom: 1px solid #f2f2f2;
  }
}

video::-internal-media-controls-download-button {
  display: none;
}

video::-webkit-media-controls-enclosure {
  overflow: hidden;
}

video::-webkit-media-controls-panel {
  width: calc(100% + 30px);
}
</style>
<style lang="scss">
// @import '@/assets/scss/index.scss'; // 引入重置样式表（覆盖浏览器用户代理样式）
// @import '@/assets/scss/modal.scss'; // 引入模态框样式表
#app {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
.el-dropdown-menu__item, .el-menu-item{
  font-size: 18px;
}
.el-submenu__title{
  font-size: 18px;
}
.el-menu-hover-bg-color, .el-menu-item.is-active, .el-menu-item:hover, .el-sub-menu.is-active .el-sub-menu__title, .el-sub-menu:not(.is-opened):hover .el-sub-menu__title{
  color: #00959b !important;
  
}
.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: none !important;
    border-bottom-color: none !important;

}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
  font-size: 18px;
  border-bottom:none !important;
  border-bottom-color: none !important;
}
.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
  color: #00959b !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #00959b !important;
}

.el-tabs {
  .el-tabs__header {
    margin: 30px 0 50px;
  }

  .el-tabs__item {
    font-size: 20px !important;
    font-weight: bold;
    padding: 0 !important;
    width: 150px;
    text-align: center;
  }

  .el-tabs__item.is-active {
    color: #fff !important;
    background: #3c9d56 !important;
    text-align: center;
    border-radius: 20px;
  }

  .el-tabs__active-bar {
    background-color: #fff;
  }

  .el-tabs__item:hover {
    color: #3c9d56;
  }

  .is-active:hover {
    color: #fff !important;
  }

  .el-tabs__content {
    overflow: unset;
  }
}

.srcospcur {
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #1d8d3b !important;
    background: #1d8d3b !important;
  }

  .el-radio__input.is-checked+.el-radio__label {
    color: #1d8d3b !important;
  }

  .subbtn {
    color: #fff;
    border: 1px solid #1d8d3b !important;
    background: #1d8d3b !important;
  }
}

@media screen and (max-width:768px) {
  .el-tabs {
    .el-tabs__header {
      margin: 20px 0 !important;
    }

    .el-tabs__item {
      font-size: 16px !important;
      font-weight: bold;
      padding: 0 !important;
      width: 110px;
    }

    .el-tabs__item.is-active {
      color: #fff !important;
      background: #3c9d56 !important;
      text-align: center;
      border-radius: 20px;
    }
  }
}
</style>
